import React from "react";
import { Box, makeStyles, Button, Hidden } from "@material-ui/core";
import { Paragraph, Title } from "../Typography";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: theme.shape.borderRadius,
  },
  content: {
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
    }
  },
  button: {
    borderRadius: "5px",
    color: theme.palette.text.secondary
  }
}));

const IntermediateStep = ({ message, description }) => {
  const classes = useStyles();

  const textArray = description?.split('\n');
  const afterButtonText = textArray?.splice(-1, 1).pop();

  return (
    <Box>
      <Hidden mdUp>
        <Box px={2}>
          <Title text={message} />
        </Box>
      </Hidden>

      <Box className={classes.container}>
        <Hidden mdDown>
          <Box>
            <Title text={message} />
          </Box>
        </Hidden>

        <Box className={classes.content}>
          <Paragraph text={textArray.join('\n')}></Paragraph>
          <Box mx="auto" mb={4} alignItems="center" textAlign="center">
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className={classes.button}
              disabled={false}
            >
              Weitere Angaben machen
            </Button>
          </Box>
          <Paragraph text={afterButtonText}></Paragraph>
        </Box>
      </Box>
    </Box>
  );
};

export default IntermediateStep;
